import React, { Component } from "react";
import DataTable from 'react-data-table-component';

const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

export const SolidaridadDetalle = ({ data, detalle, cuota }) => {


  const getColumnDetalle = () => {
    return [
      {
        name: "Cuota",
        selector: row => row.numeroCuota,
        width: "50px",
      },
      {
        name: "Importe Débito",
        selector: row => row.importeDebito
      },
      {
        name: "Importe Crédito",
        selector: row => row.importeCredito
      },
      {
        name: "Fecha Vencimiento",
        selector: row => row.fechaVencimiento

      },
      {
        name: "Último Pago",
        selector: row => row.fechaUltimoPago

      },

      {
        name: "Estado",
        selector: row => row.estado,
      }
    ];
  }

  return (
    <DataTable
      noHeader={true}
      pagination={true}
      columns={getColumnDetalle()}
      data={detalle}
      dense={true}
      paginationComponentOptions={paginationOptions}
      noDataComponent="no hay registros para mostrar"
      responsive={true}
      striped={true} />
  );

}